import { useContext } from "react";
import { Header } from "../../../components/Landing/Header/haeder.view";
import { BannerJurados } from "../components/BannerJurados";
import { TextoInicialJurados } from "../components/TextoInicialJurados";
import { Footer } from "../../../components/Landing/Footer";
import { TextoinicialNumero } from "../components/TextoinicialNumero";
import { Input, Button, Form, Table, Empty, Popover } from "antd";
import { useReconocimientosjurados } from "../../../hooks/useReconocimientosjurados";
import { EyeOutlined, EditOutlined, DeleteOutlined } from "@ant-design/icons";
import { Modaleditarconocimiento } from "./Modaleditarconocimiento";
import { Modaleliminarreconocimiento } from "./Modaleliminarreconocimiento";
import { InputNumero } from "../../../components/Mascaras/InputNumero/InputNumero";
import { InputTexto } from "../../../components/Mascaras/InputTexto/InputTexto";
import { ModalVisualizarDocumentos } from "../../../components/Generales/ModalVisualizarDocumentos";
import moment from "moment";
import { TemplateContext } from "../../../utils/template_context";
import DocumentInput from "../../../utils/DocumentInput";
import { useNavigate  } from "react-router-dom";
import { UseVerConvocatorias } from "../../../hooks/UseVerConvocatorias";

export const Reconocimientos = () => {
  const renderNavigate = useNavigate();
  const {
    getConvocatoriaPersistente,
    convocatoriaPersitente: convocatoria,
    setConvocatoriaPersitente,
    descargarArchivo,
  } = UseVerConvocatorias();
  const {
    reconocimiento,
    setReconocimiento,
    reconocimientos,
    setReconocimientos,
    agregarFila,
    modaleditar,
    setModaleditar,
    setIndexreconocimiento,
    guardarCamposModal,
    limpiarCampos,
    fileInputRef,
    guardarArchivo,
    guardarArchivoeditar,
    modaleliminar,
    setModaleliminar,
    nombrereconocimiento,
    setNombrereconocimiento,
    eliminarFila,
    continuarReconocimientos,
    modalvisualizardocumento,
    setModalVisualizarDocumento,
    documentovisualizar,
    setDocumentoVisualizar,
    indexreconocimiento,
    prevScreen,
  } = useReconocimientosjurados();
  const context = useContext(TemplateContext);
  
  const columns: any = [
    {
      title: "No.",
      width: 60,
      render: (datos: any, datos2: any, index: number) => (
        <span>{index + 1}</span>
      ),
    },
    {
      title: "Nombre reconocimiento",
      width: 200,
      dataIndex: "nombre_reconocimiento",
      key: "nombre_reconocimiento",
      fixed: context.device === "md" ? "left" : false,
      render: (datos: any) => {
        return datos.length > 27 ? (
          <Popover content={datos} title="Nombre del Reconocimiento">
            {`${datos.substring(0, 27)}...`}
          </Popover>
        ) : (
          datos
        );
      },
    },
    {
      title: "Institución que la otorga",
      width: 100,
      dataIndex: "institucion_otorga",
      key: "institucion_otorga",
      render: (datos: any) => {
        return datos.length > 27 ? (
          <Popover content={datos} title="Institución que la Otorga">
            {`${datos.substring(0, 27)}...`}
          </Popover>
        ) : (
          datos
        );
      },
    },
    {
      title: "Año",
      width: 100,
      dataIndex: "año",
      key: "año",
    },
    {
      title: "Ciudad",
      width: 100,
      dataIndex: "ciudad",
      key: "ciudad",
    },
    {
      title: "Anexar documento",
      width: 100,
      dataIndex: "documento",
      key: "documento",
    },
    {
      title: (
        <div className="row">
          <div className="col-12 d-flex justify-content-center">Acciones</div>
          <div className="col-4 text-center text-nowrap font-size-10px font-color-B0B0B0">
            Ver
          </div>
          <div className="col-4 text-center text-nowrap font-size-10px font-color-B0B0B0">
            Editar
          </div>
          <div className="col-4 text-center text-nowrap font-size-10px font-color-B0B0B0">
            Eliminar
          </div>
        </div>
      ),
      width: 100,
      render: (datos: any, datos2: any, index: number) => (
        <div className="row">
          <div className="col-4 text-center">
            <Button
              className="button-gray-ghost"
              icon={<EyeOutlined />}
              onClick={() => {
                console.log(datos, "estos son los datos");
                setDocumentoVisualizar(datos.documento);
                return setModalVisualizarDocumento(true);
              }}
            ></Button>
          </div>
          <div className="col-4 text-center">
            <Button
              className="button-gray-ghost"
              onClick={() => {
                setReconocimiento(datos);
                setIndexreconocimiento(index);
                return setModaleditar(true);
              }}
              icon={<EditOutlined />}
            ></Button>
          </div>
          <div className="col-4 text-center">
            <Button
              className="button-gray-ghost"
              onClick={() => {
                setIndexreconocimiento(index);
                setNombrereconocimiento(datos.nombre_reconocimiento);
                return setModaleliminar(true);
              }}
              icon={<DeleteOutlined />}
            ></Button>
          </div>
        </div>
      ),
    },
  ];
  
  const fields = [
    { name: "nombre_reconocimiento", value: reconocimiento.nombre_reconocimiento },
    { name: "institucion_otorga", value: reconocimiento.institucion_otorga },
    { name: "año", value: reconocimiento.año },
    { name: "ciudad", value: reconocimiento.ciudad },
    { name: "documento", value: reconocimiento.documento },
  ];

  return (
    <div>
      <Header />
      <BannerJurados BannerText="Banco de Jurados" convocatorias={convocatoria}/>
      <div className="container-fluid2">
        <TextoInicialJurados
          TituloSpan="Agrega los reconocimientos que te han otorgado"
          TitulosinSpan="(Este paso es opcional, si no cuentas con reconocimientos haz clic en el botón de continuar)"
        />
      </div>
      <div className="container-fluid2">
        <div className="col-12 p-2">
          <div className="row">
            <TextoinicialNumero
              numero="7"
              textosinspan="Agregar reconocimientos"
              textospan="Si deseas llenar este formulario recuerda que todos los campos son obligatorios"
              color="morado"
            />
          </div>
        </div>
      </div>
      <Form
        size="large"
        name="basic"
        onFinish={agregarFila}
        fields={fields}
        onFieldsChange={(_, fields: any) => {
          let infoupdate: any = { ...reconocimiento };
          for (var i in fields) {
            infoupdate[fields[i].name] = fields[i].value;
          }
          setReconocimiento(infoupdate);
        }}
      >
        <div className="container-fluid2">
          <div className="row">
            <div className="col-12 col-md-6 col-lg-6 mt-3">
              <span className="width-100 font-family-Montserrat-SemiBold font-size-12px container-span-titulos-bottom font-color-707070">
                Nombre del reconocimiento
              </span>
              <Form.Item
                className="no-margin"
                name="nombre_reconocimiento"
                rules={[{ required: true, message: "Campo obligatorio" }]}
              >
                <Input />
              </Form.Item>
            </div>
            <div className="col-12 col-md-6 col-lg-3 mt-3">
              <span className="width-100 font-family-Montserrat-SemiBold font-size-12px container-span-titulos-bottom font-color-707070">
                Institución que lo otorga
              </span>
              <Form.Item
                className="no-margin"
                name="institucion_otorga"
                rules={[{ required: true, message: "Campo obligatorio" }]}
              >
                <Input />
              </Form.Item>
            </div>
            <div className="col-12 col-md-6 col-lg-3 mt-3">
              <span className="width-100 font-family-Montserrat-SemiBold font-size-12px container-span-titulos-bottom font-color-707070">
                Año
              </span>
              <Form.Item
                className="no-margin"
                name="año"
                rules={[{ required: true, message: "Campo obligatorio" }]}
              >
                <InputNumero
                  name="año"
                  texto={reconocimiento.año}
                  setTexto={setReconocimiento}
                  alltexto={reconocimiento}
                  año={parseInt(moment().format("YYYY"))}
                />
              </Form.Item>
            </div>
            <div className="col-12 col-md-6 col-lg-6 mt-3">
              <span className="width-100 font-family-Montserrat-SemiBold font-size-12px container-span-titulos-bottom font-color-707070">
                Ciudad
              </span>
              <Form.Item
                className="no-margin"
                name="ciudad"
                rules={[{ required: true, message: "Campo obligatorio" }]}
              >
                <InputTexto
                  name="ciudad"
                  texto={reconocimiento.ciudad}
                  setTexto={setReconocimiento}
                  alltexto={reconocimiento}
                />
              </Form.Item>
            </div>
            <div className="col-12 col-md-12 col-lg-6 mt-3">
              <span className="width-100 font-family-Montserrat-SemiBold font-size-12px container-span-titulos-bottom font-color-707070">
                Anexar documento
              </span>
              <Form.Item className="no-margin" name="documento" rules={[{ required: true, message: "Documento obligatorio" }]}>
                <DocumentInput
                  doc={reconocimiento.documento}
                  fileInputRef={fileInputRef}
                  ancho_btn={30}
                  on_change={(e) => {
                    guardarArchivo(e);
                    e.target.value = ""
                  }}
                  onDelete={() => {
                    setReconocimiento({
                      ...reconocimiento,
                      documento: "",
                    });
                  }}
                />
              </Form.Item>
            </div>
            <div className="col-12 d-flex justify-content-end align-items-end">
              <Button
                className="button-azul-ghost font-size-12px"
                onClick={limpiarCampos}
                style={{ marginBottom: '20px' }}
              >
                Limpiar campos
              </Button>
              <Button
                className="button-blanco-radius font-size-12px"
                htmlType="submit"
              >
                Agregar
              </Button>
            </div>
          </div>
          <div className="col-12 row-shadow-tablas">
            <Table
              pagination={false}
              title={() => "Mi lista de reconocimientos"}
              dataSource={reconocimientos}
              columns={columns}
              locale={{
                emptyText: (
                  <Empty
                    description="No has agregado ningún reconocimiento"
                    style={{ padding: "50px" }}
                  />
                ),
              }}
              size="large"
              bordered={false}
            />
          </div>
        </div>
        <div
          className="container-fluid2 bg-white"
          style={{
            justifyContent: "center",
            position: "sticky",
            bottom: 0,
            paddingBottom: "0%",
            zIndex: 1000,
          }}
        >
          <div className="col justify-content-flex-end">
            <Button className="button-blanco-radius font-size-12px" style={{ marginRight: "16px" }} onClick={() => { return renderNavigate('/usuario/agregarExperienciaJurado') }}>Atrás</Button>
            <Button
              className="button-azul-radius font-size-12px"
              onClick={() => continuarReconocimientos()}
            >
              Continuar
            </Button>
          </div>
        </div>
      </Form>
      <Footer />
      <ModalVisualizarDocumentos
        state={{ documento: documentovisualizar }}
        visualizar={modalvisualizardocumento}
        setVisualizar={setModalVisualizarDocumento}
        tipo="participante"
      />
      <Modaleditarconocimiento
        reconocimiento={reconocimiento}
        setReconocimiento={setReconocimiento}
        reconocimientos={reconocimientos}
        setReconocimientos={setReconocimientos}
        modal={modaleditar}
        setModal={setModaleditar}
        guardarcambios={guardarCamposModal}
        limpiarcampos={limpiarCampos}
        guardarArchivoeditar={guardarArchivoeditar}
        indexReconocimiento={indexreconocimiento}
      />
      <Modaleliminarreconocimiento
        modal={modaleliminar}
        nombre={nombrereconocimiento}
        cancelar={() => setModaleliminar(false)}
        eliminar={() => eliminarFila(indexreconocimiento)}
      />
    </div>
  );
};
